namespace Matrix {
    export interface SupportTicketSendEmailRequest extends Serenity.ServiceRequest {
        Subject?: string;
        Body?: string;
    }
}
